// Legal policy content for NovaWorks Global Solutions

export const CONTACT = {
  company: "NovaWorks Global Solutions, Inc",
  email: "hello@novaworksglobal.com",
  phone: "1 (844) 656-1470",
  address: ["116 Agnes Rd, Ste 200", "Knoxville, TN 37919"],
};

export const TERMS = {
  slug: "terms",
  title: "Terms & Conditions",
  effective: "June 6, 2026",
  updated: "August 21, 2026",
  intro: [
    "Welcome to the website of NovaWorks Global Solutions (“NovaWorks,” “Company,” “we,” “us,” or “our”). These Terms & Conditions (“Terms”) govern your access to and use of our website, communications, and services.",
    "By accessing this website, submitting information through the website, requesting information about our services, or engaging NovaWorks for services, you acknowledge that you have read and agree to these Terms.",
  ],
  sections: [
    {
      heading: "1. Business Services",
      body: [
        "NovaWorks Global Solutions provides business process outsourcing (“BPO”) and related services to business clients. Services may include virtual and dedicated staffing, customer service and customer support, back-office support, administrative services, lead engagement and follow-up, appointment setting, telemarketing and outbound calling, inbound call handling, live call transfer services, live chat and messaging support, data processing and CRM support, quality assurance, operational support, and other customized outsourcing and staffing solutions.",
        "The exact scope, pricing, performance standards, staffing requirements, deliverables, and other conditions applicable to a client engagement may be established in a separate Service Agreement, Master Services Agreement (“MSA”), Statement of Work (“SOW”), order form, proposal, or other written agreement.",
      ],
    },
    {
      heading: "2. Business-to-Business Services",
      body: [
        "NovaWorks primarily provides services to businesses and organizations. Unless expressly agreed otherwise in writing, our services are not offered as consumer products or services.",
        "Individuals contacted by NovaWorks personnel on behalf of a client are not considered purchasers of NovaWorks services. In those situations, NovaWorks is providing contracted services on behalf of its business client.",
      ],
    },
    {
      heading: "3. Client Agreements",
      body: [
        "Clients may be required to enter into a separate written agreement before services begin. If there is any conflict between these website Terms and a separately executed Service Agreement, MSA, SOW, or other written agreement between NovaWorks and a client, the executed written agreement will control with respect to that client engagement.",
      ],
    },
    {
      heading: "4. Fees and Payment",
      body: [
        "Fees vary depending on the services provided and may be calculated using hourly rates, dedicated staffing rates, fixed monthly charges, per-call rates, per-transfer rates, performance-based rates, or other mutually agreed billing methods.",
        "Applicable pricing, billing frequency, payment terms, minimum commitments, and billable performance criteria will be stated in the applicable proposal, invoice, SOW, Service Agreement, or other written agreement.",
        "Clients are responsible for reviewing invoices and promptly notifying NovaWorks of billing questions or disputes. Failure to make payment when due may result in suspension or termination of services, subject to the applicable client agreement.",
      ],
    },
    {
      heading: "5. Service Performance",
      body: [
        "NovaWorks will use commercially reasonable efforts to provide services professionally and in accordance with the applicable client agreement. Unless specifically guaranteed in a written agreement, NovaWorks does not guarantee any particular number of sales, appointments, leads, transfers, conversions, revenue, customer acquisitions, or other business result.",
        "Results may be affected by factors outside NovaWorks’ control, including lead quality, lead volume, client availability, client sales practices, telecommunications systems, third-party software, market conditions, consumer behavior, and other external factors.",
      ],
    },
    {
      heading: "6. Client Responsibilities",
      body: [
        "Clients are responsible for providing accurate information, instructions, system access, training materials, scripts, lead data, account credentials, compliance requirements, and other resources reasonably necessary for NovaWorks to perform contracted services.",
        "Clients are also responsible for ensuring that data, leads, contact information, scripts, offers, and instructions supplied to NovaWorks may lawfully be used for the intended purpose. Unless otherwise expressly agreed in writing, the client remains responsible for the legality and accuracy of its products, services, advertising claims, offers, pricing, and business practices.",
      ],
    },
    {
      heading: "7. Compliance",
      body: [
        "NovaWorks intends to conduct its services in accordance with applicable laws and regulations. Clients may not use NovaWorks services for unlawful, fraudulent, deceptive, abusive, or unauthorized activities.",
        "Clients must inform NovaWorks of industry-specific compliance requirements applicable to their campaigns or business operations. NovaWorks reserves the right to suspend or terminate any service that it reasonably believes violates applicable law, regulatory requirements, contractual obligations, or Company policy.",
      ],
    },
    {
      heading: "8. Confidentiality and Data",
      body: [
        "In performing services, NovaWorks may receive confidential business information, customer information, lead information, account credentials, scripts, reports, CRM data, and other information belonging to clients.",
        "NovaWorks will use commercially reasonable measures to protect confidential information and will use such information for legitimate business purposes associated with providing contracted services, except as otherwise authorized or required by law. Additional confidentiality, data-security, or data-processing obligations may be established in the applicable client agreement.",
      ],
    },
    {
      heading: "9. Third-Party Platforms and Services",
      body: [
        "NovaWorks may use third-party software, telecommunications providers, CRM platforms, dialers, cloud services, payment processors, communication platforms, analytics providers, and other vendors. NovaWorks is not responsible for interruptions, outages, errors, security incidents, policy changes, or other failures caused solely by third-party systems outside NovaWorks’ reasonable control.",
      ],
    },
    {
      heading: "10. Intellectual Property",
      body: [
        "Unless otherwise agreed in writing, the NovaWorks name, logos, website content, graphics, processes, training materials, documentation, and other Company-created materials are owned by or licensed to NovaWorks and may not be copied, reproduced, distributed, or commercially used without authorization. Clients retain ownership of their own trademarks, customer information, proprietary materials, and other intellectual property supplied to NovaWorks.",
      ],
    },
    {
      heading: "11. Website Use",
      body: [
        "Users may not use the website for unlawful or fraudulent purposes; attempt unauthorized access to systems; interfere with website operation or security; introduce malware or malicious code; scrape or reproduce content for unauthorized commercial purposes; or misrepresent their identity or affiliation.",
      ],
    },
    {
      heading: "12. Cancellation and Termination",
      body: [
        "Cancellation and termination rights for contracted services are governed by the applicable Service Agreement, MSA, SOW, proposal, or other written agreement. Unless otherwise specified in writing, cancellation does not eliminate responsibility for fees already earned, services already performed, committed staffing, or other amounts properly incurred before the effective cancellation date.",
      ],
    },
    {
      heading: "13. Disclaimer of Warranties",
      body: [
        "To the maximum extent permitted by law, the website and services are provided on an “as available” basis. Except for obligations expressly stated in a written client agreement, NovaWorks makes no warranty that its services will produce any specific commercial, financial, sales, conversion, or operational result.",
      ],
    },
    {
      heading: "14. Limitation of Liability",
      body: [
        "To the maximum extent permitted by applicable law, NovaWorks will not be liable for indirect, incidental, special, consequential, exemplary, or punitive damages, including lost profits, lost revenue, lost business opportunities, or loss of data, arising from use of the website or services. Additional limitations applicable to a client engagement will be governed by the applicable written agreement.",
      ],
    },
    {
      heading: "15. Indemnification",
      body: [
        "To the extent permitted by law and subject to any applicable written agreement, clients agree to indemnify and hold NovaWorks harmless from third-party claims arising from unlawful or unauthorized materials, data, instructions, products, services, or representations supplied by the client for use in connection with NovaWorks’ services.",
      ],
    },
    {
      heading: "16. Changes to These Terms",
      body: [
        "NovaWorks may update these Terms periodically. Updated Terms will be posted with a revised “Last Updated” date. Changes to website Terms will not retroactively modify an executed client agreement unless agreed to in writing.",
      ],
    },
    {
      heading: "17. Governing Law",
      body: [
        "These Terms will be governed by the laws of the jurisdiction specified in the applicable client agreement. Where no separate written agreement applies, these Terms will be governed by the laws applicable to NovaWorks Global Solutions, without regard to conflict-of-law principles.",
      ],
    },
  ],
};

export const PRIVACY = {
  slug: "privacy",
  title: "Privacy Policy",
  effective: "June 6, 2026",
  updated: "August 21, 2026",
  intro: [
    "NovaWorks Global Solutions (“NovaWorks,” “we,” “us,” or “our”) respects the privacy and security of personal information. This Privacy Policy describes how we may collect, use, disclose, retain, and protect information when you visit our website, communicate with us, request information, become a client, or otherwise interact with NovaWorks.",
  ],
  sections: [
    {
      heading: "1. Information We May Collect",
      body: [
        "We may collect contact and business information such as name, company, job title, business address, email, telephone number, and information submitted through inquiry forms; client/account information such as service requirements, project specifications, billing information, communications, and service history; and website/technical information such as IP address, browser/device type, operating system, pages visited, referring website, access time, and website interactions.",
        "We may use cookies, analytics technologies, server logs, and similar technologies.",
      ],
    },
    {
      heading: "2. Information Processed on Behalf of Clients",
      body: [
        "As a BPO and outsourcing provider, NovaWorks may process information supplied or controlled by business clients while providing contracted services. This may include customer or prospective-customer names, telephone numbers, email addresses, lead information, CRM records, call information, customer-service records, appointment information, communications, and other data necessary to perform contracted services.",
        "When NovaWorks processes such information solely on behalf of a business client, the client generally determines the purpose for which information is collected and used, subject to applicable agreements and law.",
      ],
    },
    {
      heading: "3. How We Use Information",
      body: [
        "We may use information to respond to inquiries; provide services; establish and manage client accounts; communicate with clients; staff and operate projects; provide customer support; process transactions; prepare invoices and reports; monitor service quality; maintain operational records; detect fraud or security threats; protect systems; maintain legal and regulatory compliance; enforce agreements; resolve disputes; and operate and improve our website and business.",
      ],
    },
    {
      heading: "4. How We Share Information",
      body: [
        "NovaWorks does not sell personal information merely because it receives or processes that information in connection with providing BPO services.",
        "We may disclose information to cloud/hosting providers, telecommunications providers, CRM/software providers, payment processors, IT/cybersecurity providers, professional advisers, contractors, and other service providers reasonably necessary to operate our business or provide services. We may also disclose information when required by law, legal process, court order, regulatory request, or when reasonably necessary to protect NovaWorks, clients, personnel, or others.",
      ],
    },
    {
      heading: "5. Client Data",
      body: [
        "Client data remains subject to the applicable client agreement. NovaWorks does not claim ownership of a client’s proprietary customer lists, lead information, CRM data, or other client-owned information solely because NovaWorks processes that information while providing services.",
      ],
    },
    {
      heading: "6. Data Security",
      body: [
        "NovaWorks uses reasonable administrative, technical, and organizational safeguards designed to protect information from unauthorized access, disclosure, alteration, misuse, or destruction. No internet transmission, telecommunications system, or electronic storage method can be guaranteed completely secure.",
      ],
    },
    {
      heading: "7. Data Retention",
      body: [
        "We retain information for as long as reasonably necessary to provide services, maintain business and financial records, satisfy contractual obligations, resolve disputes, protect legal rights, meet compliance obligations, and comply with applicable laws.",
      ],
    },
    {
      heading: "8. Cookies and Analytics",
      body: [
        "Our website may use cookies and similar technologies for functionality, security, analytics, and performance measurement. Where required by applicable law, users will be provided appropriate choices regarding non-essential cookies or tracking technologies.",
      ],
    },
    {
      heading: "9. Your Privacy Rights",
      body: [
        "Depending on applicable law and residence, individuals may have rights to request access, correction, deletion, information regarding use/disclosure, and certain opt-outs. Not all rights apply in every jurisdiction or circumstance.",
        "When NovaWorks processes information solely on behalf of a business client, requests concerning that information may need to be submitted to the applicable client.",
      ],
    },
    {
      heading: "10. California Privacy Rights",
      body: [
        "Where applicable California privacy laws apply to NovaWorks, eligible California residents may have rights concerning access, deletion, correction, disclosure, portability, sale or sharing of personal information, sensitive personal information, and non-discrimination for exercising applicable rights.",
      ],
    },
    {
      heading: "11. Sale of Personal Information",
      body: [
        "NovaWorks does not sell personal information collected through this website in exchange for monetary compensation. If practices change or applicable law defines activities as a sale or sharing requiring additional disclosures or opt-out rights, NovaWorks will provide required notices and choices.",
      ],
    },
    {
      heading: "12. Children’s Privacy",
      body: [
        "NovaWorks provides business services and does not intentionally market services to children. Our website is not intended for children under 13, and we do not knowingly collect personal information directly from children under 13 through this website.",
      ],
    },
    {
      heading: "13. International Operations and Data Processing",
      body: [
        "NovaWorks may use personnel, contractors, service providers, technology systems, or facilities located in different jurisdictions. Information may therefore be processed or accessed from countries other than the country where it was originally collected, subject to applicable contractual requirements and data-protection laws.",
      ],
    },
    {
      heading: "14. Third-Party Websites",
      body: [
        "NovaWorks is not responsible for the privacy practices, content, or security of third-party websites or services linked from our website.",
      ],
    },
    {
      heading: "15. Changes to This Privacy Policy",
      body: [
        "We may update this Privacy Policy periodically. The revised policy will be posted with an updated “Last Updated” date.",
      ],
    },
  ],
};

export const REFUND = {
  slug: "refund",
  title: "Refund & Cancellation Policy",
  effective: "June 6, 2026",
  updated: "August 21, 2026",
  intro: [
    "NovaWorks Global Solutions (“NovaWorks,” “we,” “us,” or “our”) provides customized BPO, staffing, customer-support, telemarketing, lead-engagement, and related professional services to business clients. Because services involve labor, staffing commitments, telecommunications expenses, software resources, and other operational costs, refunds are handled according to this policy and any applicable written client agreement.",
  ],
  sections: [
    {
      heading: "1. Service Cancellation",
      body: [
        "Clients may cancel or terminate services according to the applicable Service Agreement, MSA, SOW, proposal, order form, or other written agreement. Where a written agreement specifies a notice period, minimum service period, staffing commitment, or other cancellation requirement, those terms control.",
      ],
    },
    {
      heading: "2. Services Already Performed",
      body: [
        "Fees for services already performed are generally non-refundable. This includes completed staffing hours; dedicated staffing provided or reserved; completed calls; qualified or billable transfers; appointment-setting services; customer-support services; back-office or administrative services; completed project work; telecommunications usage; setup or implementation work; and other completed deliverables.",
        "Cancellation of future services does not cancel payment obligations for services already provided or charges already earned.",
      ],
    },
    {
      heading: "3. Prepaid Services",
      body: [
        "If a client has prepaid for services not yet performed, any refund or account credit will be determined according to the applicable client agreement. Unless otherwise agreed in writing, NovaWorks may deduct services already performed, non-refundable third-party costs, setup expenses, committed staffing, and other properly incurred charges before calculating a refund or credit.",
      ],
    },
    {
      heading: "4. Billing Errors",
      body: [
        "If a client believes an invoice contains an error, duplicate charge, incorrect calculation, or charge for a service not provided in accordance with the applicable agreement, the client should contact NovaWorks promptly. We will review legitimate disputes using available records, which may include time records, call records, system logs, service reports, CRM records, and project records. If an incorrect charge is confirmed, NovaWorks may issue an appropriate refund, credit, or billing adjustment.",
      ],
    },
    {
      heading: "5. Performance-Based Services",
      body: [
        "For services billed according to defined performance criteria, such as completed calls, connected transfers, appointments, or other measurable deliverables, the applicable Service Agreement, SOW, or written project terms determine when a service becomes billable. A properly documented deliverable satisfying agreed billing criteria is considered a completed service and is generally non-refundable.",
      ],
    },
    {
      heading: "6. Client Dissatisfaction",
      body: [
        "Dissatisfaction with business results does not automatically qualify a client for a refund where NovaWorks performed the contracted services. Unless expressly guaranteed in writing, NovaWorks does not guarantee sales, revenue, conversion rates, customer acquisitions, appointments, closing percentages, or other specific business outcomes.",
      ],
    },
    {
      heading: "7. Third-Party Costs",
      body: [
        "Third-party expenses incurred specifically for a client may be non-refundable once incurred, including telecommunications charges, software licensing, platform fees, purchased resources, implementation costs, or other attributable third-party expenses.",
      ],
    },
    {
      heading: "8. Chargebacks and Payment Disputes",
      body: [
        "Clients should contact NovaWorks directly regarding billing questions or disputed charges so NovaWorks has an opportunity to investigate and resolve the matter. Initiating a chargeback or payment dispute does not eliminate amounts legitimately owed for services properly performed and documented.",
        "NovaWorks reserves the right to provide contracts, invoices, service records, call records, time records, communications, system records, and other relevant documentation to payment processors, financial institutions, or other parties as reasonably necessary to respond to a payment dispute.",
      ],
    },
    {
      heading: "9. Refund Processing",
      body: [
        "When NovaWorks approves a refund, it will generally be issued to the original payment method whenever reasonably possible. Processing times may vary depending on the payment processor, bank, card issuer, and payment method.",
      ],
    },
    {
      heading: "10. Contract Terms Control",
      body: [
        "This website policy provides NovaWorks’ general refund and cancellation practices. If a client’s executed Service Agreement, MSA, SOW, proposal, or other written agreement contains different refund, cancellation, dispute, or payment terms, the executed written agreement will control.",
      ],
    },
  ],
};

export const POLICIES = { terms: TERMS, privacy: PRIVACY, refund: REFUND };
